// extracted by mini-css-extract-plugin
module.exports = {"content":"Obeyxh","title":"B_KKwb","isMobile":"KCCj9g"};